var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"two-line":""}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.weather.name)+", "+_vm._s(_vm.weather.sys.country))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.weather.weather[0].description))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }